export const featureFlags = {
  accountContactInformationNewUi: 'accountContactInformationNewUi',
  additinalContactsRewrite: 'additinalContactsRewrite',
  borrowerDisableSmsLoginOption: 'borrowerDisableSmsLoginOption',
  callNotes: 'callNotes',
  callTranscription: 'callTranscription',
  caseEvents: 'caseEvents',
  chargeFeeTool: 'chargeFeeTool',
  collectionAgenciesEnabled: 'collectionAgenciesEnabled',
  creditAgenciesEnabled: 'creditAgenciesEnabled',
  crmCallHold: 'crmCallHold',
  crmCaseAssignment: 'crmCaseAssignment',
  dashboardTool: 'dashboardTool',
  draftEmailRewrite: 'draftEmailRewrite',
  draftMailRewrite: 'draftMailRewrite',
  draftTextRewrite: 'draftTextRewrite',
  drawFundsShowButton: 'drawFundsShowButton',
  enableTemplateEditing: 'enableTemplateEditing',
  hideUnfinishedUnifiedAdminDemoNav: 'hideUnfinishedUnifiedAdminDemoNav',
  interactionRewrite: 'interactionRewrite',
  issueRefundTool: 'issueRefundTool',
  loanLabels: 'loanLabels',
  loanTapesEnabled: 'loanTapesEnabled',
  loanTypeCloning: 'loanTypeCloning',
  loanTypeTemplates: 'loanTypeTemplates',
  loanTypesRedesignV1: 'loanTypesRedesignV1',
  manageAutopayRewrite: 'manageAutopayRewrite',
  manageCardStatus: 'manageCardStatus',
  manageRefundsTool: 'manageRefundsTool',
  membershipFeeEnabled: 'membershipFeeEnabled',
  metabaseV1: 'metabaseV1',
  objectChangedEvents: 'objectChangedEvents',
  pastMailRewrite: 'pastMailRewrite',
  paymentMethodRefactorEnabled2026: 'paymentMethodRefactorEnabled2026',
  paymentPlan: 'paymentPlan',
  promoProgramTypesEnabled: 'promoProgramTypesEnabled',
  summarizeCase: 'summarizeCase',
  supercaseEvents: 'supercaseEvents'
}